export default __webpack_public_path__ + "static/media/DarkBlue0005.a45f9e4d.png";